import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import App1Image from "../../assets/images/app1.svg";
import App2Image from "../../assets/images/app2.svg";
import App3Image from "../../assets/images/app3.svg";
import App4Image from "../../assets/images/app4.svg";
import Section from "../../components/Section";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { Parallax, ParallaxLayer } from "@react-spring/parallax";
import videoBg from "../../assets/videos/videoBg.mp4";
import Input from "../../components/Input";
import CategorySelect from "../../components/CategorySelect";
import Button from "../../components/Button";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import StoreContent from "../../components/StoreContent";
import useWindowSize from "../../../utils/hooks/useWindowSize";
import { Post } from "../../network/httpClient";

const schema = yup
  .object({
    name: yup.string().required("Name is required"),
    mobileNo: yup
      .string()
      .required("Mobile number is required")
      .matches(/^[0-9]+$/, "Must be only digits")
      .length(10, "Must be exactly 10 digits"),
    emailId: yup.string().email().required("Email id is required"),
    profileCategoryId: yup.string().required("Category is required"),
    socialMediaLink: yup.string().optional()
  })
  .required();

const Home = () => {
  const windowSize = useWindowSize();
  const isMobileView = windowSize.x < 950;
  const [submitted, setSubmitted] = useState(false); // State to track whether the form has been submitted
  const [isFabVisible, setIsFabVisible] = useState(false);
  const positionRef = useRef(0);
  const parallaxRef = useRef(null);
  const debounceTimerRef = useRef(null); // To store the timer ID
  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      name: "",
      mobileNo: "",
      emailId: "",
      profileCategoryId: "",
      socialMediaLink: ""
    }
  });

  const showButtonWithDelay = () => {
    const minLimit = window.innerHeight * 2;
    if (positionRef.current > minLimit) {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
      debounceTimerRef.current = setTimeout(() => {
        if (positionRef.current > minLimit) {
          setIsFabVisible(true);
        }
      }, 1000);
    }
  };

  const isMobileLandscape = windowSize.x > windowSize.y && windowSize.x <= 915;

  const onSubmit = async (data) => {
    console.log(data);
    const request = {
      name: data.name,
      mobileNo: data.mobileNo,
      emailId: data.emailId,
      profileCategory: {
        id: data.profileCategoryId
      },
      socialMediaLink: data.socialMediaLink
    };
    try {
      const response = await Post("waitlist/add", request);
      if (response.code === 200) {
        if (response.data.length) {
          parallaxRef.current.scrollTo(0);
          setSubmitted(true);
        } else {
          alert(response.message);
        }
      }
    } catch (error) {
      console.log(error);
      alert("Something went wrong. Please try again later.");
    }
  };

  const handleScroll = () => {
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    parallaxRef.current.scrollTo(1);
    setIsFabVisible(false);
  };

  const checkScrollPosition = () => {
    console.log("Scroll Position:", window.innerHeight);
    if (parallaxRef.current) {
      positionRef.current = parallaxRef.current.current;
      console.log("Current Scroll Position:", positionRef.current);
      showButtonWithDelay();
    }
  };

  return (
    <div className="waitlist main-bg">
      <Parallax
        className="parallax-container"
        ref={parallaxRef}
        pages={isMobileView ? 4.78 : 5.5}
        style={{ top: 0, left: 0, right: 0, bottom: 0 }}
        onScrollCapture={checkScrollPosition}>
        <ParallaxLayer offset={0} speed={0} factor={0.2} sticky={{ start: 0, end: 1 }}>
          <div style={{ backgroundColor: "#000000", zIndex: 999 }}>
            <Header />
          </div>
        </ParallaxLayer>
        <ParallaxLayer
          offset={0}
          speed={0}
          factor={1}
          sticky={{ start: 0, end: 1 }}
          style={{ zIndex: -2 }}>
          <div style={{ position: "relative", height: "100%" }}>
            <div className="video-container mesh-overlay" style={{ zIndex: 1 }} />
            <video
              className="video-container"
              autoPlay="autoplay"
              loop="loop"
              muted
              src={videoBg}
              playsInline
            />
          </div>
        </ParallaxLayer>
        {!submitted ? (
          <ParallaxLayer offset={0} speed={0.2} factor={1}>
            <div
              style={{
                flex: 1,
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}>
              <div style={{ zIndex: 1, display: "flex", justifyContent: "center" }}>
                <h2 style={{}} className="redefine">
                  Redefining Talent Discovery
                </h2>
                <div className="line" style={{ height: `37%` }} />
                <h2
                  className="main-title sub-title"
                  style={{
                    position: "absolute",
                    bottom: 10,
                    textTransform: "uppercase",
                    color: "#FFF"
                  }}>
                  Join the waiting list
                </h2>
              </div>
            </div>
          </ParallaxLayer>
        ) : (
          <ParallaxLayer offset={0} speed={0} factor={1}>
            <div
              style={{
                display: "flex",
                height: "100%",
                justifyContent: "center",
                alignItems: "center",
                padding: "0 20px",
                flexDirection: "column"
              }}>
              <h2 className="main-title" style={{ textTransform: "uppercase" }}>
                YOU’RE ON THE LIST!
              </h2>
              <div className="thankyou">Stay tuned while we work our magic behind the scenes.</div>
            </div>
          </ParallaxLayer>
        )}
        {!submitted ? (
          <ParallaxLayer offset={1} speed={0} factor={1} sticky={{ start: 1, end: 1 }}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
                height: "100%",
                zIndex: 99,
                boxSizing: "border-box"
              }}>
              <h2 className="main-title" style={{ textTransform: "uppercase", margin: 0 }}>
                Empower Your Journey To Stardom
              </h2>
              <h2 className="main-title sub-title" style={{}}>
                Gain exclusive access and updates by joining the waiting list.
              </h2>
              <form
                onSubmit={handleSubmit(onSubmit)}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "440px",
                  zIndex: 99,
                  marginTop: 15
                }}>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    flexDirection: isMobileLandscape ? "row" : "column",
                    gap: isMobileLandscape ? 20 : 0
                  }}>
                  <Input
                    control={control}
                    error={errors.name?.message}
                    name="name"
                    label="Name"
                    placeholder="Enter Name"
                  />
                  <Input
                    control={control}
                    error={errors.mobileNo?.message}
                    name="mobileNo"
                    label="Mobile Number"
                    placeholder="Enter Mobile Number"
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    flexDirection: isMobileLandscape ? "row" : "column",
                    gap: isMobileLandscape ? 20 : 0
                  }}>
                  <Input
                    control={control}
                    error={errors.emailId?.message}
                    name="emailId"
                    label="Email"
                    placeholder="Enter Email Address"
                  />
                  {isMobileLandscape && (
                    <Input
                      control={control}
                      name="socialMediaLink"
                      label="Instagram Account"
                      placeholder="Enter Instagram Account"
                      optional
                    />
                  )}
                </div>

                <CategorySelect
                  control={control}
                  name="profileCategoryId"
                  error={errors.profileCategoryId?.message}
                />
                {!isMobileLandscape && (
                  <Input
                    control={control}
                    name="socialMediaLink"
                    label="Instagram Account"
                    placeholder="Enter Instagram Account"
                    optional
                  />
                )}
                <Button value="Join the list"></Button>
              </form>
            </div>
          </ParallaxLayer>
        ) : (
          <ParallaxLayer className="dark-bg" offset={1} speed={0}>
            <div
              style={{
                display: "flex",
                height: "100%",
                justifyContent: "center",
                alignItems: "center",
                padding: "0 20px",
                flexDirection: "column"
              }}>
              <h2 style={{}} className="redefine">
                Redefining Talent Discovery
              </h2>
              <div className="line line2" style={{ height: "40%" }} />
            </div>
          </ParallaxLayer>
        )}
        <ParallaxLayer offset={2} speed={0} factor={isMobileView ? 0.62 : 0.8}>
          <Section
            appImage={App1Image}
            title="Create Your Profile and Get Discovered"
            subtitle="Build your portfolio and become part of the industry."
          />
        </ParallaxLayer>
        <ParallaxLayer
          offset={isMobileView ? 2.62 : 2.8}
          speed={0}
          factor={isMobileView ? 0.62 : 0.8}>
          <Section
            reverse
            appImage={App4Image}
            title="Apply for Auditions across India"
            subtitle="Artists can apply for auditions taking place all over India."
          />
        </ParallaxLayer>
        <ParallaxLayer
          offset={isMobileView ? 3.24 : 3.6}
          speed={0}
          factor={isMobileView ? 0.62 : 0.8}>
          <Section
            appImage={App2Image}
            title="Create Auditions and Streamline Talent Discovery and Hiring"
            subtitle="Find the best talent for your project and organise your database."
          />
        </ParallaxLayer>
        <ParallaxLayer
          offset={isMobileView ? 3.86 : 4.4}
          speed={0}
          factor={isMobileView ? 0.62 : 0.8}>
          <Section
            reverse
            appImage={App3Image}
            title="Learn from Industry Experts in Exclusive Masterclasses"
            subtitle="Elevate your craft under the guidance of industry legends."
          />
        </ParallaxLayer>
        <ParallaxLayer offset={isMobileView ? 4.48 : 5.2} speed={0} factor={0.3}>
          <div
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between"
            }}>
            <StoreContent />
            <Footer />
          </div>
        </ParallaxLayer>
      </Parallax>
      {!submitted && isFabVisible && (
        <button className="floating-button" onClick={handleScroll}>
          Join the list
        </button>
      )}
    </div>
  );
};

export default Home;
